import $ from 'jquery';

import './visualcaptcha.jquery';

export const initCaptcha = (selector: string, namespace: string, onLoading?: any) => {
  const $element = $(selector);

  $element.visualCaptcha({
    templates: {
      button:
        '\n                                    \u003Cdiv class=\u0022visualCaptcha-{class}-button\u0022\u003E\n                                        \u003Ca href=\u0022javascript:;\u0022\u003E\n                                            \u003Cimg src=\u0022{path}{class}{retinaExtra}.png\u0022\u003E\n                                        \u003C/a\u003E\n                                    \u003C/div\u003E',
      buttonGroup:
        '\u003Cdiv class=\u0022visualCaptcha-button-group\u0022\u003E{btnRefresh}\u003C/div\u003E',
    },
    language: {
      accessibilityAlt: 'Sound icon',
      accessibilityTitle: 'Accessibility option: listen to a question and answer it!',
      accessibilityDescription:
        'Type below the \u003Cstrong\u003Eanswer\u003C/strong\u003E to what you hear. Numbers or words:',
      explanation: 'Click or touch the \u003Cstrong\u003EANSWER\u003C/strong\u003E',
      refreshAlt: 'Refresh/reload icon',
      refreshTitle: 'Refresh/reload: get new images and accessibility option!',
    },
    imgPath: '/img/',
    captcha: {
      url: '/visualcaptcha',
      numberOfImages: 5,
      namespace,
      namespaceFieldName: 'namespace',
      routes: {
        start: '/start',
        image: '/image',
        audio: '/audio',
      },
      callbacks: {
        loaded: onLoading,
      },
    },
  });
};

export const getCaptchaValue = (selector: string) =>
  $(selector).find('.form-control.imageField').val() as string;

export const getCaptchaName = (selector: string) =>
  $(selector).find('.form-control.imageField').attr('name') as string;

export const refreshCaptca = (selector: string) =>
  $(selector).find('.visualCaptcha-refresh-button').trigger('click');
